/**
 * QuotesPage — `/quotes`: every CIS quote (`QT-`) in the caller's scope, sent
 * from a draft quote built in One and live until the customer decides
 * (docs/features/order-to-invoice/40_quotes_module_spec.md §10). Tharstern's
 * estimates are a separate, read-only page. Filtered, searched and sorted on
 * the server.
 *
 * Staff only, behind the `quotes` feature.
 */
import { Link } from "react-router";
import { paths } from "@shared-core/routing/routes";
import { QuotesList } from "../app/components/domain/quotes/QuotesList";

export function QuotesPage() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl">Quotes</h1>
        <p className="text-sm text-muted-foreground">
          Quotes stay live until the customer decides. Tharstern's estimates are
          under{" "}
          <Link to={paths.estimates()} className="underline">
            Estimates
          </Link>
          .
        </p>
      </div>
      <QuotesList />
    </div>
  );
}
